"use strict";
var metaKeys = ['comments', 'references', 'flags', 'thesaurus_id', 'lod_data'];
var META_FIELD_NAME = 'metadata';
var transform = {
  jsonStringsFromSchema: function(schema, values) {
    var schemaJson = JSON.parse(schema);
    var valuesJson;
    if (values.length > 0) {
      valuesJson = JSON.parse(values);
    }
    return this.fromSchema(schemaJson, valuesJson);
  },
  sortFields: function(fields, explicit_order) {
    var ordered = [];
    var indices = {};
    if (explicit_order) {
      for (var i = 0; i < explicit_order.length; ++i)
        indices[explicit_order[i]] = i;
    }
    for (var i in fields)
      ordered.push(fields[i]);
    var sortFunc = function(f1, f2) {
      var n1 = f1.schema.name;
      var n2 = f2.schema.name;
      var i1 = indices[n1];
      var i2 = indices[n2];
      if (typeof(i1) !== "undefined" && typeof(i2) == "undefined")
        return -1;
      else if (typeof(i1) == "undefined" && typeof(i2) !== "undefined")
        return 1;
      else if ($traceurRuntime.typeof((i1)) != undefined && typeof(i2) != "undefined")
        return i1 - i2;
      else
        return f1.schema.index - f2.schema.index;
    };
    ordered.sort(sortFunc);
    return ordered;
  },
  metaFromSchema: function(valuesJson, entry, i, key) {
    if (typeof valuesJson[META_FIELD_NAME] != 'undefined' && typeof valuesJson[META_FIELD_NAME][key] != 'undefined' && valuesJson[META_FIELD_NAME][key] != null && typeof valuesJson[META_FIELD_NAME][key][i] != 'undefined') {
      for (var metaKey in valuesJson[META_FIELD_NAME][key][i]) {
        entry[metaKey] = valuesJson[META_FIELD_NAME][key][i][metaKey];
      }
    }
    return entry;
  },
  valueFromSchema: function(values, entry, i) {
    var value = values[i];
    if (typeof value != 'undefined') {
      entry['value'] = value;
    }
    return entry;
  },
  entriesFromSchema: function(values, key) {
    var entries = [];
    if (typeof values != 'undefined' && values[key] != null) {
      for (var i = 0; i < values[key].length; i++) {
        var entry = {};
        entry = this.valueFromSchema(values[key], entry, i, key);
        entry = this.metaFromSchema(values, entry, i, key);
        entries.push(entry);
      }
      ;
    }
    return entries;
  },
  fromSchema: function(schemaJson, valuesJson) {
    var data = {};
    for (var key in schemaJson) {
      var entries = this.entriesFromSchema(valuesJson, key);
      var field = {
        entries: entries,
        schema: schemaJson[key]
      };
      data[field.schema.name] = field;
    }
    return data;
  },
  metaToSchema: function(entries) {
    var entriesMeta = [];
    for (var i = 0; i < entries.length; i++) {
      var entryMeta = {};
      for (var metaKeyIndex in metaKeys) {
        var metaKey = metaKeys[metaKeyIndex];
        entryMeta[metaKey] = entries[i][metaKey];
      }
      entriesMeta.push(entryMeta);
    }
    return entriesMeta;
  },
  valuesToSchema: function(entries) {
    var entriesValue = [];
    for (var i = 0; i < entries.length; i++) {
      entriesValue.push(entries[i].value);
    }
    return entriesValue;
  },
  toSchema: function(data) {
    var values = {};
    var meta = {};
    for (var key in data) {
      var keyData = data[key];
      values[key] = this.valuesToSchema(keyData.entries);
      meta[key] = this.metaToSchema(keyData.entries);
    }
    values[META_FIELD_NAME] = meta;
    var newData = {values: values};
    return newData;
  }
};
module.exports = transform;
